/**
 * feature-config flag names owned by analyze
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const ANALYZE_FLAG_NAMES = {
  ANALYZE_GROWTH_EXPERIMENT: 'ff-wfa-1703-analyze-growth-experiment-user-group',
  ANALYZE_COMPETE_GROWTH_IPN: 'ff-wfa-1862-analyze-compete-growth-ipn',
  ANALYZE_GROWTH_ON_PUBLISH: 'ff-wfa-1789-growth-on-publish',
  ANALYZE_DEMO_MODE: 'ff-wfa-1869-analyze-demo-mode',
  ANALYZE_AUDIENCE_REPORTING: 'ff-wfa-1940-audience-reporting',
  ANALYZE_AUDIENCE_FILTERING: 'ff-wfa-1934-audience-filtering',
  ANALYZE_AUDIENCE_FILTERING_BACKFILL:
    'ff-wfa-2061-audience-filtering-backfill',
  ANALYZE_GOAL_INTEROP: 'ff-op-2647-analyze-optimize-goal-interop',
  ANALYZE_AUDIENCE_CREATION: 'ff-cri-118-audience-creation',
  CLICKHOUSE_TO_DRUID: 'ff-cri-150-clickhouse-to-druid',
  ANALYZE_SITE_GOAL: 'ff-cri-206-site-goals',
  ANALYZE_NEST_PREVIEW_ROUTES: 'ff-wfa-2101-nest-preview-routes',
  ASSET_FILE_SIZE_FROM_MONGO: 'ff-cri-asset-file-size-from-mongo',
  ANALYZE_NEST_SPLIT_PERFORMANCE: 'ff-aeo-nest-split-performance',
  ANALYZE_PUBLIC_TRAFFIC_ENABLED: 'ff-cri-261-analyze-public-traffic-enabled',
  ANALYZE_PUBLIC_TOP_PAGES_ENABLED:
    'ff-cri-267-analyze-public-top-pages-enabled',
  ANALYZE_PUBLIC_TOP_DIMENSIONS_ENABLED:
    'ff-cri-271-analyze-public-top-dimensions-enabled',
  ANALYZE_PUBLIC_TOP_EVENTS_ENABLED:
    'ff-cri-282-analyze-public-top-events-enabled',
  ANALYZE_TOTAL_SESSIONS_USERS_AGGREGATE_QUERY:
    'ff-wfa-1452-total-sessions-users-total-query-change',
  ANALYZE_PUBLIC_TIME_ON_PAGE_ENABLED:
    'ff-cri-285-analyze-public-time-on-page-enabled',
  ANALYZE_PUBLIC_SCROLL_DEPTH_ENABLED:
    'ff-cri-288-analyze-public-scroll-depth-enabled',
  ANALYZE_PUBLIC_BROWSER_WINDOW_HEIGHT_ENABLED:
    'ff-cri-291-analyze-public-browser-window-height-enabled',
  ANALYZE_PUBLIC_PAGE_FLOW_ENABLED:
    'ff-cri-275-analyze-public-page-flow-enabled',
  ANALYZE_PUBLIC_GOALS_ENABLED: 'ff-cri-279-analyze-public-goals-enabled',
  ANALYZE_PUBLIC_GOAL_PERFORMANCE_ENABLED:
    'ff-cri-294-analyze-public-goal-performance-enabled',
  ANALYZE_PUBLIC_PER_TOKEN_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-cri-387-analyze-public-per-token-concurrency-limit-enforce-enabled',
  ANALYZE_PUBLIC_AGGREGATE_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-cri-387-analyze-public-aggregate-concurrency-limit-enforce-enabled',
  ANALYZE_ADDITIONAL_LLM_FILTERS: 'ff-wfa-2203-additional-llm-filters',
  ANALYZE_ENTERPRISE_INTEGRATIONS:
    'ff-wfa-2502-analyze-enterprise-integrations',
  ANALYZE_EVENT_DATA_DELETED_ELEMENTS:
    'ff-wfa-1366-event-data-deleted-elements',
  ANALYZE_TOP_EVENTS_CUSTOM_EVENTS: 'ff-wfa-2264-top-events-custom-events',
};

export const ANALYZE_DYNAMIC_CONFIG_NAMES = {
  ANALYZE_PUBLIC_CONCURRENCY_LIMIT:
    'dc-cri-387-analyze-public-concurrency-limit',
} as const;
